import { TeamIcon, UserAvatar, type UserAvatarProps } from "@faro-lotv/flat-ui";
import { type JSX } from "react";

export type UserTeamAvatarProps = UserAvatarProps & {
  isTeam: boolean;
};

/** @returns An user avatar stylized based on if the input user is a single one or a team */
export function UserTeamAvatar({
  isTeam,
  displayOption,
  ...props
}: UserTeamAvatarProps): JSX.Element {
  return (
    <UserAvatar
      {...props}
      displayOption={isTeam ? "nameOnly" : displayOption}
      icon={isTeam ? <TeamIcon sx={{ width: "16px" }} /> : undefined}
    />
  );
}
